module.exports = __webpack_public_path__ + "img/LogoMyfrac@2x.fc91c838.png";